import { combineReducers } from '@reduxjs/toolkit';
import account from '@Hotels-at-Home/hah-fe-core/dist/store/account';
import user from '@Hotels-at-Home/hah-fe-core/dist/store/user';
import category from '@Hotels-at-Home/hah-fe-core/dist/store/category';
import cart from '@Hotels-at-Home/hah-fe-core/dist/store/cart';
import checkout from '@Hotels-at-Home/hah-fe-core/dist/store/checkout';
import wishlist from '@Hotels-at-Home/hah-fe-core/dist/store/wishlist';
import product from '@Hotels-at-Home/hah-fe-core/dist/store/product';
import modal from '@Hotels-at-Home/hah-fe-core/dist/store/modal';
import prefill from '@Hotels-at-Home/hah-fe-core/dist/store/prefill';
import currencies from '@Hotels-at-Home/hah-fe-core/dist/store/currencies';
import cookieSettings from '@Hotels-at-Home/hah-fe-core/dist/store/cookieSettings';
import captcha from '@Hotels-at-Home/hah-fe-core/dist/store/captcha';
import ymal from '@Hotels-at-Home/hah-fe-core/dist/store/ymal';

const combinedReducer = combineReducers({
  account,
  user,
  category,
  cart,
  checkout,
  wishlist,
  product,
  modal,
  prefill,
  currencies,
  cookieSettings,
  captcha,
  ymal,
});

export default combinedReducer;
